<template>
    <div class="base-recharge" :class="{ 'recharge-sp': $store.state.screen == 1 }">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="onBack">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">平台币充值</div>
                <div class="ser" @click="onBill">账单记录</div>
            </div>
            <div class="content-auto">
                <div class="list">
                    <div class="currency">我的平台币：<span>{{ $route.query.num || 0 }}</span></div>
                    <div class="ratio">充值比例：1平台币={{ $route.query.rmb }}RMB</div>
                </div>
                <div class="problem">
                    <div class="line"></div>
                    <div>请选择充值金额</div>
                </div>
                <div class="money">
                    <div class="num" :class="{ isnum: isnum == index }" v-for="(item, index) in moneyList" :key="index"
                        @click="onNum(index)">{{ item }}元</div>
                    <input
                        onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                        onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                        class="num" placeholder="自定义要充值的金额" text="text" v-model="reMoney" @focus="onFocus" />
                </div>
                <div class="problem">
                    <div class="line"></div>
                    <div>请选择充值方式</div>
                </div>
                <div class="mode-list">
                    <div class="mode" :class="{ ismode: ispay == index }" v-for="(item, index) in payMode" :key="index"
                        @click="ispay = index">
                        <img class="pay" :src="item.img" />
                        <img class="select" src="~images/select.png" v-show="ispay == index" />
                    </div>
                </div>
                <div class="tips">
                    平台币说明：不会过期，不支持退款，请确定后充值！<br />
                    充值方式：在游戏内充值，选择“平台币”支付。<br />
                    使用范围：平台币只支持充值BT版游戏，其他版块不支持！
                </div>
                <transition name="component-fade" mode="out-in">
                    <TheTips :msg='msg' v-if="msg" />
                </transition>
            </div>
        </div>
        <div class="btn" @click="onPay">立即充值</div>
    </div>
</template>

<script>
import TheTips from '@/components/TheTips'

export default {
    name: 'BaseRecharge',
    components: {
        TheTips
    },
    data() {
        return {
            msg: null,
            moneyList: ['50', '80', '100', '500', '1000', '2000'],
            isnum: 0,
            reMoney: '',
            payMode: [
                {
                    img: require('images/pay.png'),
                    id: 2
                },
                {
                    img: require('images/wx.png'),
                    id: 4
                }
            ],
            ispay: 0,
            money: '',
            accountData: {},
            payParams: {},
            appid: '',
            channel: '',
            uid: '',
            appUid: '',
            appkey: '',
            times: null,
            isCloudPlay: 0//云玩1:是云玩,0不是云玩
        }
    },
    methods: {
        onBack() {
            clearInterval(this.times)
            sessionStorage.removeItem('orderID')
            this.$router.back()
        },
        onBill() {
            clearInterval(this.times)
            sessionStorage.removeItem('orderID')
            this.$router.push('/base-bill')
        },
        onNum(index) {
            this.isnum = index
            this.reMoney = ''
        },
        onFocus() {
            this.isnum = null
        },
        onPay() {
            this.money = this.isnum == null ? this.reMoney : this.moneyList[this.isnum]
            if (!this.money.replace(/\s*/g, "")) {
                this.msg = '请选择充值金额'
                setTimeout(() => {
                    this.msg = null
                }, 2000)
                return false
            }
            this.payStart()
        },
        // 开始支付
        payStart() {
            let money = this.reMoney ? this.reMoney : this.moneyList[this.isnum]
            let options = {
                deviceType: this.config.system, // 2苹果，1安卓
                appid: this.appid,
                channel: this.channel, // 渠道
                uid: this.uid, // 用户ID
                app_uid: this.appUid, // 小号ID
                serverID: 0, // 区服ID
                serverNAME: 0, // 区服名
                roleID: 0, // 角色ID
                roleNAME: 0, // 角色名
                productID: 0, // 产品ID
                productNAME: 0, // 产品名
                payType: this.payMode[this.ispay].id, // 支付方式
                payMode: 3, // 充值类型(1正常充值 2GM权限充值 3平台币充值)
                // cardID: '', // 充值卡号
                // cardPass: '', // 充值密码
                // cardMoney: '', // 充值卡金额
                amount: Number.parseInt(money), // 充值金额
                // origPrice: payParams.origPrice, // 原价(从研发获取,折扣服才有值,没有传0)
                extend: 0 // 扩展字段
            }
            options.sign = this.util.getSign(options, this.appkey)
            options.origPrice = Number.parseInt(money) // 原价(从研发获取,折扣服才有值,没有传0)
            if (this.config.system == 1) {
                options.android_id = this.$route.query.androidId ? this.$route.query.androidId : this.accountData.machine_id // 安卓ID(不进入签名)
                options.imei = this.$route.query.machine_code ? this.$route.query.machine_code : this.accountData.machine_code // 安卓设备号(不进入签名)
            }
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=pay&a=payStart', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    if (res.data.data.url) {
                        this.orderID = res.data.data.orderID
                        sessionStorage.setItem('orderID', this.orderID)
                        if (this.isCloudPlay == 1) {
                            this.msg = '云玩支付测试'
                            setTimeout(() => {
                                this.msg = null
                                // 云玩支付
                                window.Android.onCloudPlayPay(res.data.data.url, res.data.data.amount, res.data.data.orderID)
                            }, 2000)

                        } else {
                            location.href = res.data.data.url + '&money=' + res.data.data.amount + '&order=' + res.data.data.orderID
                        }
                    }
                } else {
                    this.msg = res.data.msg
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                }
            }).
                catch(o => {
                    this.msg = '请求失败'
                    setTimeout(() => {
                        this.msg = null
                    }, 2000)
                })
        },
        // 支付查询
        payQuery() {
            let options = {
                uid: this.uid,
                orderID: this.orderID
            }
            options.sign = this.util.getSign(options, this.appkey)
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=pay&a=payQuery', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    if (res.data.data.order_status == 1) {
                        sessionStorage.removeItem('orderID')
                        clearInterval(this.times)
                        // 更新钱包列表缓存
                        this.getProperty()
                        this.msg = '充值成功'
                        setTimeout(() => {
                            this.msg = null
                            this.$router.back()
                        }, 1000)
                        // 成功
                    } else if (res.data.data.order_status == 2) {
                        // 发货中
                    } else if (res.data.data.order_status == 3) {
                        // 未支付
                    }
                }
            })
        },
        // 获取钱包列表
        getProperty() {
            let options = {
                uid: this.uid,
                appid: this.appid
            }
            options.sign = this.util.getSign(options, this.appkey)
            this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=userbox&a=property', this.$qs.stringify(options)).then(res => {
                if (res.data.status == 1) {
                    sessionStorage.setItem('setWallet', JSON.stringify(res.data.data))
                }
            })
        }
    },
    created() {

        let that = this

        let Base64 = require('js-base64').Base64

        that.accountData = JSON.parse(sessionStorage.getItem('accountData'))

        that.channel = that.accountData.channel
        that.appkey = that.accountData.appkey
        that.uid = that.accountData.uid
        that.appid = that.accountData.appid
        // 云玩
        this.isCloudPlay = that.accountData.isCloudPlay == 1 ? 1 : 0

        // 安卓
        if (that.config.system == 1) {
            that.uid = window.Android.getUid()
            that.appUid = window.Android.getCUid()
            that.payParams = JSON.parse(window.Android.getPayParams())
        } else if (that.config.system == 2) { // ios
            window.appIosCallback = function (data) {

                let iosInfo = JSON.parse(Base64.decode(data))

                that.channel = iosInfo.getChannel ? iosInfo.getChannel : that.accountData.channel

                that.appkey = iosInfo.getAppKey ? iosInfo.getAppKey : that.accountData.appkey

                that.appid = iosInfo.getAppId ? iosInfo.getAppId : that.accountData.appid

            }

            window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'getAppInfo' })

            window.IosGetPayParamsCallback = function (data) {
                that.payParams = JSON.parse(Base64.decode(data))
                that.uid = that.payParams.getUid
                that.appUid = that.payParams.getCUid
            }
            window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'getPayParams' })
        }

        if (sessionStorage.getItem('orderID')) {
            that.orderID = sessionStorage.getItem('orderID')
            that.times = setInterval(() => {
                that.payQuery()
            }, 3000)
        }

    },
    // 离开组件时清除定时器
    destroyed() {
        let that = this
        clearInterval(that.times)
        sessionStorage.removeItem('orderID')
    }
}
</script>

<style lang="scss" scoped>
$color: #FF6C22;

// 横屏css
.base-recharge {
    width: 1080px;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    transition: all 0.3s;

    .content {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;

        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                .back {
                    width: 72px;
                    height: 72px;
                }
            }

            .title {
                font-size: 51px;
                text-align: center;
            }

            .ser {
                height: 132px;
                font-size: 39px;
                position: absolute;
                right: 60px;
                display: flex;
                align-items: center;
            }
        }

        .content-auto {
            flex: 1;
            overflow-y: scroll;
            padding: 60px;
        }

        .list {
            height: 210px;
            border-radius: 18px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 45px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .currency {
                font-size: 36px;
            }

            .currency span {
                font-size: 60px;
            }

            .ratio {
                font-size: 30px;
                color: rgba(255, 255, 255, 0.5);
                margin-top: 26px;
            }
        }

        .problem {
            font-size: 45px;
            margin: 80px 0 50px;
            display: flex;
            align-items: center;

            .line {
                width: 12px;
                height: 24px;
                background: $color;
                margin: 5px 19px 0 0;
            }
        }

        .money {
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .num {
                width: 300px;
                height: 120px;
                font-size: 48px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 12px;
                margin-bottom: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .num:last-child {
                width: 100%;
                font-size: 42px;
                color: #fff;
                border: 0;
                border-radius: 18px;
                margin-bottom: 0;
                padding: 0 45px;
                outline: none;
                display: flex;
                align-items: center;
            }

            .isnum {
                background: $color;
            }
        }

        .mode-list {
            height: 160px;
            display: flex;
            justify-content: space-between;

            .mode {
                width: 450px;
                height: 160px;
                border-radius: 18px;
                border: 3px solid #e6e6e6;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
            }

            .mode .pay {
                width: 230px;
                height: 81px;
            }

            .mode .select {
                width: 72px;
                height: 72px;
                position: absolute;
                top: -3px;
                right: -3px;
            }

            .mode:last-child .pay {
                width: 230px;
                height: 72px;
            }

            .ismode {
                border-color: $color;
            }
        }

        .tips {
            color: rgba(255, 255, 255, 0.5);
            font-size: 36px;
            margin-top: 60px;
        }
    }

    .btn {
        height: 120px;
        font-size: 39px;
        border-radius: 18px;
        background: $color;
        margin: 0 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

// 竖屏css
.recharge-sp {
    width: 100%;
    height: 100%;
    padding-bottom: 90px;

    .content {
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;

            .back-img {
                width: 290px;
                height: 240px;

                .back {
                    width: 130px;
                    height: 130px;
                }
            }

            .title {
                font-size: 92px;
            }

            .ser {
                height: 240px;
                font-size: 60px;
                right: 80px;
            }
        }

        .content-auto {
            padding: 90px;
        }

        .list {
            height: 380px;
            border-radius: 32px;
            padding: 0 81px;

            .currency {
                font-size: 65px;
            }

            .currency span {
                font-size: 90px;
            }

            .ratio {
                font-size: 54px;
                margin-top: 47px;
            }
        }

        .problem {
            font-size: 81px;
            margin: 145px 0 90px;

            .line {
                width: 21px;
                height: 43px;
                margin: 9px 34px 0 0;
            }
        }

        .money {
            .num {
                width: 430px;
                height: 200px;
                font-size: 80px;
                border-radius: 21px;
                margin-bottom: 54px;
            }

            .num:last-child {
                font-size: 76px;
                border-radius: 32px;
                padding: 0 81px;
            }
        }

        .mode-list {
            height: 250px;

            .mode {
                width: 650px;
                height: 250px;
                border-radius: 32px;
                border: 5px solid #e6e6e6;
            }

            .mode .pay {
                width: 400px;
                height: 120px;
            }

            .mode .select {
                width: 130px;
                height: 130px;
                top: -5px;
                right: -5px;
            }

            .mode:last-child .pay {
                width: 400px;
                height: 120px;
            }

            .ismode {
                border-color: $color;
            }
        }

        .tips {
            font-size: 65px;
            margin-top: 90px;
        }
    }

    .btn {
        height: 200px;
        font-size: 70px;
        border-radius: 32px;
        margin: 0 90px;
    }
}
</style>